/**
 * This is simple JWT API for testing purposes.
 * https://github.com/pinia-studio/jwt-api-node
**/

export const JWT_HOST_API = "https://jwt-api-node.vercel.app";

/**
 * Get the appropriate Keycloak client ID based on the active module
 */
function getClientId() {
  const module = import.meta.env.VITE_REACT_APP_MODULE?.toUpperCase();
  
  // Map module to its specific client ID
  const clientIdMap = {
    MONITORING: import.meta.env.VITE_KEYCLOAK_CLIENT_ID_MONITORING,
    INDUSTRIAL: import.meta.env.VITE_KEYCLOAK_CLIENT_ID_INDUSTRIAL,
    MANAGER: import.meta.env.VITE_KEYCLOAK_CLIENT_ID_MANAGER,
    ANALYSIS: import.meta.env.VITE_KEYCLOAK_CLIENT_ID_ANALYSIS,
    ADMIN: import.meta.env.VITE_KEYCLOAK_CLIENT_ID_ADMIN,
  };
  
  return clientIdMap[module] || import.meta.env.VITE_KEYCLOAK_CLIENT_ID || "henddu-monitoring-web";
}

export const KEYCLOAK_CONFIG = {
    url: import.meta.env.VITE_KEYCLOAK_URL || "https://auth.dev.henddu.com",
    realm: import.meta.env.VITE_KEYCLOAK_REALM || "henddu-system",
    clientId: getClientId()
  };